import { useMemo } from 'react';

import { DropdownPillComboboxSingleAdd } from 'ui-kit';
import { PillButton } from 'ui-kit/Buttons';
import { keyBy } from 'lodash';

import { StratKey, stratificationsConfig } from './startifications.config';

const allStrats = Object.keys(stratificationsConfig) as StratKey[];

export function StratsSelection(props: {
  selectedStrats: StratKey[];
  onSelectedStratsChange: (strats: StratKey[]) => void;
  'data-tour'?: string;
}) {
  function addStrat(strat: StratKey) {
    props.onSelectedStratsChange([...props.selectedStrats, strat]);
  }
  function removeStrat(strat: StratKey) {
    props.onSelectedStratsChange(props.selectedStrats.filter((s) => s !== strat));
  }

  const selectedMap = useMemo(() => keyBy(props.selectedStrats), [props.selectedStrats]);
  const options = useMemo(
    () =>
      allStrats
        .filter((st) => !selectedMap[st])
        .map((st) => ({
          value: st,
          label: stratificationsConfig[st]?.label || '',
        })),
    [selectedMap],
  );

  return (
    <div
      data-tour={props['data-tour'] || 'stratifications-strats-selection'}
      className="flex flex-wrap items-center gap-2 font-heebo text-[12px] font-normal leading-[1.67] text-[slate-400] [&>button]:m-0"
    >
      <span>Strat by:</span>{' '}
      {props.selectedStrats.map((strat) => (
        <PillButton
          description={stratificationsConfig[strat]?.label || ''}
          key={strat}
          iconName="pill-close"
          onClick={() => removeStrat(strat)}
        />
      ))}
      <div data-tour={props['data-tour'] ? `${props['data-tour']}-add-button` : undefined}>
        <DropdownPillComboboxSingleAdd
          options={options}
          buttonLabel="Add Stratification"
          onValueSelected={(option) => addStrat(option.value)}
          data-testid="strats-selection-add-button"
        />
      </div>
    </div>
  );
}
